import { useState, useMemo, useEffect } from "react";
import { fetchWrapper } from "data/FetchWrapper";
import {
  ResponseType,
  RegExFileExtension,
  ImageFileExtensions,
} from "data/Types";

const useImagePreview = (response = {}) => {
  const [unique, setUnique] = useState(response.id);
  const [image, setImage] = useState(response.image);
  let isImage = false;
  if (response.responseType === ResponseType.FILE) {
    isImage = ImageFileExtensions.includes(
      RegExFileExtension.exec(response.title)[0]
    );
  }
  // handle row change
  useEffect(() => {
    if (!image && response.responseType === ResponseType.FILE && isImage) {
      fetchWrapper
        .download(`/api/file/${response.id}`)
        .then((image) => setImage(URL.createObjectURL(image)))
        .catch((e) => console.log(e));
    } else if (
      image &&
      response.responseType !== ResponseType.FILE &&
      response.responseType !== ResponseType.GOOGLE
    ) {
      setImage(null);
    }
    return () => {
      URL.revokeObjectURL(image);
    };
  }, [image, response.id, response.responseType, isImage]);
  // handle response change
  useEffect(() => {
    if (
      unique !== response.id &&
      response.responseType === ResponseType.FILE &&
      isImage
    ) {
      fetchWrapper
        .download(`/api/file/${response.id}`)
        .then((image) => {
          setImage(URL.createObjectURL(image));
          setUnique(response.id);
        })
        .catch((e) => console.log(e));
    }
  }, [unique, response.id, response.responseType, isImage]);
  const isLoading = !image && response.responseType === ResponseType.FILE;
  return useMemo(() => [image, isImage, isLoading], [
    image,
    isImage,
    isLoading,
  ]);
};
export { useImagePreview };
